import { Component, Input } from "@angular/core";
import { DynamicDialogConfig } from "primeng/dynamicdialog";

@Component({
  selector: "app-data-list-display-modal",
  imports: [],
  templateUrl: "./data-list-display-modal.component.html",
  styleUrl: "./data-list-display-modal.component.scss",
})
export class DataListDisplayModalComponent {
  @Input()
  data: Record<string, unknown>[] = [];

  @Input()
  displayFields: DisplayField[] = [];

  constructor(private readonly dialogConfig: DynamicDialogConfig) {
    this.data = this.dialogConfig.data.data;
    this.displayFields = this.dialogConfig.data.displayFields;
  }
}

interface DisplayField {
  key: string;
  label?: string;
}